// --------------------------------------------------------------------------
// trueHover.js
// --------------------------------------------------------------------------
// Uses https://github.com/twbs/mq4-hover-shim to detect true hover in the browser
// --------------------------------------------------------------------------

EC.trueHover = function() {

  'use strict';

  var trueHover;

  function init() {
    $(document).on('mq4hsChange', setTrueHover);
  }

  function setTrueHover (e) {
    $(document.documentElement).toggleClass('true-hover', e.trueHover);
    trueHover = e.trueHover;
  }

  function getTrueHover () {
    return trueHover;
  }

  return {
    init: init,
    getTrueHover: getTrueHover
  };

}();